import { Helmet } from 'react-helmet';
import { siteConfig } from '../config.js';
import SectionA from '../components/AboutUsSectionA.js';
import SectionB from '../components/AboutUsSectionB.js';
import SectionC from '../components/AboutUsSectionC.js';
import JoinOurCommunity from '../components/JoinOurCommunityWhite.js';
import Header from '../components/Header.js';
import PreFooter from '../components/PreFooter';
import Footer from '../components/Footer';

export default function AboutUsPage() {
  return (
    <>
      <Helmet>
        <title>About Us | {siteConfig.title}</title>
        <meta name="description" content={siteConfig.metaDescription} />
      </Helmet>

      <Header config={siteConfig} />
        <SectionA />  
        <SectionB />  
        <SectionC />  
        <JoinOurCommunity />  
      <PreFooter />
      <Footer />
    </>
  );
}
